import { useState, useEffect } from 'react';
import { listenToCollection } from '../services/firestore.service';
import { where } from 'firebase/firestore';

export const useCarbonCredits = (userId) => {
  const [credits, setCredits] = useState([]);
  const [totalTonnes, setTotalTonnes] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!userId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    const unsubscribe = listenToCollection(
      'carbon_credits',
      [where('ownerId', '==', userId)],
      (data) => {
        setCredits(data);
        // Calculate total quantity
        const tonnes = data.reduce((acc, curr) => acc + (curr.quantity || 0), 0);
        setTotalTonnes(tonnes);
        setLoading(false);
      },
      (err) => {
        setError(err);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [userId]);

  return { credits, totalTonnes, loading, error };
};

